// extracted by mini-css-extract-plugin
module.exports = {"player_scorm_box__nodata":"styles_player_scorm_box__nodata__roNc8"};